var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 59.5,
    fill: "#680005"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 64.5C0 77.2569 3.78286 89.7273 10.8702 100.334C17.9576 110.941 28.0311 119.208 39.8169 124.09C51.6027 128.972 64.5715 130.249 77.0833 127.761C89.5951 125.272 101.088 119.129 110.108 110.108C119.129 101.088 125.272 89.5951 127.761 77.0833C130.249 64.5715 128.972 51.6027 124.09 39.8169C119.208 28.0311 110.941 17.9576 100.334 10.8702C89.7273 3.78286 77.2569 0 64.5 0C47.3935 0 30.9877 6.79551 18.8916 18.8916C6.79551 30.9877 0 47.3935 0 64.5ZM27.6429 59.8928H83.6196L57.9118 34.0606L64.5 27.6429L101.357 64.5L64.5 101.357L57.9118 94.7827L83.6196 69.1071H27.6429V59.8928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextBtn);
export default __webpack_public_path__ + "static/media/NextBtn.d612029c27498075145aa360f49886f8.svg";
export { ForwardRef as ReactComponent };